import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { route } from '~/app/helpers/route';
import usePageTitle from '~/app/hooks/usePageTitle';
import useTranslation from '~/app/hooks/useTranslation';
import { useAppHeader } from '~/app/modules/appHeader';
import { Machine } from '~/types';
import { useStoreState } from '~/store';
import { ROUTES } from "~/app/Router";
import List from './List';
import EmptyMessage from '~/issueService/EmptyMessage';
import { IssueOrServiceType } from '~/app/data/statuses/chat';

export type TrainingComponent = React.FC;

const Training: TrainingComponent = () => {
  const { id } = useParams<{ id: Machine['id'] }>();
  
  const { t } = useTranslation('machine.details');

  const history = useHistory();
  const { setData } = useAppHeader();

  const machine = useStoreState(state => state.machine.data);
  const trainings = useStoreState(state => state.machine.data.trainings);

  usePageTitle((machine.name || '').toUpperCase());

  useEffect(() => {
    setData({
      title: (machine.name || '').toUpperCase(),
      subTitle: `${machine.intern} - ${machine.name}`.toUpperCase(),
      backLink: history.length > 1 ? history.goBack : route(ROUTES.projects),
      showUser: false,
      machineId: '',
      projectId: '',
      showMachineMessages: false,
      isIssueDetailPage: false,
      notification: false,
      search: false
    });
  }, [setData, id, machine, t, history]);

  return (
    <>
      {trainings.length ? <List list={trainings} /> : <EmptyMessage type={IssueOrServiceType.ISSUE} />}
    </>
  );
};
export default Training
